var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mt-2",attrs:{"show":true,"variant":"secondary"}},[_c('h3',[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v("\n        Hello,\n        "+_vm._s(_vm.user.person.first_name)+" "+_vm._s(_vm.user.person.last_name)+",\n        Welcome back!\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }